import SearchHistory from '../common/search.history';
import InstantSearch from '../common/search.instant';
import SearchForm from '../common/search.form';

$(() => {
  const $searchInput = $('#book_search_input').eq(0);
  const $searchHistoryWrap = $('.js_search_history_wrap').eq(0);
  const updateViewCallback = isEmpty => {
    $searchHistoryWrap.toggleClass('history_empty', isEmpty);
  };

  const searchHistory = SearchHistory.isEnabled() ? new SearchHistory({
    $wrapper: $searchHistoryWrap,
    $list: $('#search_history'),
    $template: $('.js_search_history_tmpl').removeClass('js_search_history_tmpl').remove(),
    $btnClearAll: $('.js_btn_clear_history'),
    $btnTurnOffHistory: $('.js_btn_turn_off_history'),
    $btnTurnOnHistory: $('.js_btn_turn_on_history'),
    updateViewCallback,
  }, 5) : null;

  const instantSearch = new InstantSearch($('#book_search_result'), searchHistory);

  const searchForm = new SearchForm({
    $wrapper: $('.js_search_wrap'),
    $form: $('#search_form'),
    $input: $searchInput,
    $btnResetInput: $('.js_btn_reset_search_input'),
    instantSearch,
    searchHistory,
  });
});



// WEBPACK FOOTER //
// ./ridi/ridi.search.js